import React, { useState, type FC } from 'react';
import { Mail } from 'lucide-react';
import { CardShell } from './card-shell';
import type { ToolCardProps } from './types';
import { safeGet } from './types';

export const MessageDraftCard: FC<ToolCardProps> = ({ result }) => {
  const [expanded, setExpanded] = useState(false);

  const message =
    safeGet<string>(result, 'message') ??
    (typeof result === 'string' ? result : undefined) ??
    '';

  if (!message) return null;

  return (
    <CardShell>
      <div style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Mail size={16} style={{ color: 'var(--text-tertiary)', flexShrink: 0 }} />
          <span
            style={{
              fontSize: 13,
              color: 'var(--text-tertiary)',
            }}
          >
            Draft outreach
          </span>
        </div>

        {/* Message body */}
        <div
          onClick={() => setExpanded(!expanded)}
          style={{
            fontSize: 14,
            color: 'var(--text-primary)',
            lineHeight: '20px',
            whiteSpace: 'pre-wrap',
            cursor: 'pointer',
            ...(expanded
              ? {}
              : {
                  display: '-webkit-box',
                  WebkitLineClamp: 6,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }),
          }}
        >
          {message}
        </div>

        {/* Footer */}
        <div
          style={{
            fontSize: 12,
            color: 'var(--text-tertiary)',
          }}
        >
          Review and send when ready
        </div>
      </div>
    </CardShell>
  );
};
